<template>
    <div class="box software-show-box home-Progressive-hidden">
        <div class="box-title">
            <img style="width: 30rem;height: 5.5rem;" src="../../assets/image/home/title.png" alt="">
            <div class="title">虚仿软件</div>
        </div>
        <div class="statistics-box">
            <div v-for="(item,index) in softwareStatisticsData" class="statistics-item" :key="index">
                <img class="soft-img" :src="item.img" alt="">
                <div class="soft-btm">
                    <p class="soft-number">{{ item.number||0 }}</p>
                    <p class="soft-label">{{ item.label }}</p>
                </div>
            </div>
        </div>
        <div class="card-box">
            <show-card @view_course="toSoftwareDetail" :dataList="softwareList"></show-card>
        </div>
    </div>
</template>

<script>
import ShowCard from '../course/ShowCard.vue';
import { GetHomeSoftware,GetOptCount } from '@/api/home';
export default {
  components: { ShowCard },
        data(){
            return {
                /**软件列表数据 */
                softwareList:[],
                courseList:[],
                /**虚仿软件统计数据 */
                softwareStatisticsData:[
                    {
                        label:'实训人数',
                        value:'study',
                        img:require('../../assets/image/home/study.png'),
                        number:0
                    },
                    {
                        label:'实训次数',
                        value:'study_count',
                        img:require('../../assets/image/home/study_count.png'),
                        number:0
                    },
                    {
                        label:'点赞数',
                        value:'like',
                        img:require('../../assets/image/home/likes.png'),
                        number:0
                    },
                    {
                        label:'收藏数',
                        value:'collect',
                        img:require('../../assets/image/home/collect.png'),
                        number:0
                    },
                ]
            }
        },
        methods:{
            /**跳转仿真软件详情 */
            toSoftwareDetail(item){
                this.$router.push({
                path:'/virtualSimulation/detail',
                query:{
                    id:item.id
                }
             });
            },
             /**获取操作数量 */
            getOptCount() {
                GetOptCount().then(res => {
                    if (res.code == 200) {
                        var obj={};
                        res.data.forEach(item=>{
                            obj[item.optType]=item.count;
                        })
                        this.softwareStatisticsData.forEach(item=>{
                            item.number=obj[item.value];
                        })
                    }
                })
            },
            toCourseDetail(data){
                this.$router.push({
                    path:'/course/courseDetail',
                    query: { id: data.id }
                });
            },
            /**获取仿真软件 */
            getHomeSoftware(){
                GetHomeSoftware().then(res=>{
                    if(res.code==200){
                        res.data.forEach(item=>{
                            item.coverImageUrl=item.softwareCover;
                            item.courseName=item.softwareName;
                            item.courseDescription=item.explainInfo;
                        })
                        this.softwareList=res.data;
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
.first-bg-img:hover{
    transform: translateY(-1rem);
}
.left-bg:hover{
    transform: translateY(-1rem);
}
.right-bg:hover{
    transform: translateY(-1rem);
}
.bottom-bg:hover{
    transform: translateY(-1rem);
}
.box{
    margin-top: 12rem;
    .box-title{
        color: #151C34;
        font-size: 3.4rem;
        font-weight: 700;
        text-align: center;
        .title{
            margin-top: -5rem;
        }
    }
}
.course-box{
    padding: 6.4rem 0 20rem 0;
    display: flex;
    color: #FFFFFF;
    .first-bg-img{
        cursor: pointer;
        height: 59rem;
        width: 57rem;
        background-size: cover;
        background-repeat: no-repeat;
        padding: 0 6rem;
        white-space: var(--lineWrap);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        &> :nth-child(1){
            font-size: 3rem;
            margin-bottom: 6rem;
        }
        &> :nth-child(2){
            font-size: 16px;
        }
    }
}
.right-bg-img{
    margin-left: 3rem;
    flex: 1;
}
.top-bg{
    width: 100%;
    display: flex;
    height: calc(100% - 31rem);
    .left-bg{
        cursor: pointer;
        flex: 1;
        background-image: url(../../assets/image/home/zpshnt.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.8rem;
        transition: all 0.3s;
    }
    .right-bg{
        cursor: pointer;
        flex: 1;
        margin-left: 3rem;
        background-image: url(../../assets/image/home/zpsgjg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.8rem;
        transition: all 0.3s;
    }
}
.bottom-bg{
    cursor: pointer;
    margin-top: 3rem;
    width: 100%;
    height: 28rem;
    background-image: url(../../assets/image/home/xjhnt.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    transition: all 0.3s;
}
.card-box{
    padding: 7.5rem var(--padding);
}
.statistics-item{
    height: 27rem;
    width: calc((100% - 15rem)/4);
    background-color: #F0F5FF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -10rem;
}
.statistics-box{
    display: flex;
    padding: 0 var(--padding);
    gap: 3rem;
    justify-content: space-between;
    margin-top: 20rem;
    margin-bottom: 5rem;
    background-image: url('../../assets/image/home/b-003.png');
    height: 26rem;
}
.soft-img{
    width: 4rem;
    height: auto;
}
.soft-number{
    color: #151C34;
    font-size: 3.6rem;
    font-weight: 700;
    margin-top: 3rem;
}
.soft-btm{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.soft-label{
    color: #626D91;
}
@media screen and (max-width:750px){
    .statistics-box{
        flex-wrap: wrap;
        margin-top: 10rem;
        height: auto !important;
        margin-top: 3rem;
        margin-bottom: 1rem;
        background-image: url('../../assets/image/phone/05.png') !important;
        background-position-y: bottom;
        background-repeat: no-repeat;
        background-size: 100%;
    }
    .statistics-item{
        width: calc(50% - 2rem);
        margin-top: 3rem;
    }
    .software-show-box{
        margin-top: 5rem;
    }
    .card-box{
        padding-top: 3rem;
    }
}
</style>